"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _arrays = require("@mulesoft/exchange-ui-portals-store/lib/utils/arrays");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _exchangeUiComponents = require("@mulesoft/exchange-ui-components");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _utils = require("../../LifecycleState/utils");
var _constants = require("../../constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "lifecycle-minor-statuses-container": "Statuses__lifecycle-minor-statuses-container__36jR1",
  "lifecycleMinorStatusesContainer": "Statuses__lifecycle-minor-statuses-container__36jR1",
  "icon": "Statuses__icon__3QsrZ"
}; 
require('./Statuses.css');
var LifecycleStateIcon = function LifecycleStateIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m13.22 0 1.177 1.684H6.183L2.056 7.578l4.127 5.894h8.214l-1.179 1.684H5.306L0 7.578 5.306 0h7.913Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m10.104 5.642-.842-.59v4.716l.842-.59L12.63 7.41"
  }));
};
LifecycleStateIcon.defaultProps = {
  viewBox: "0 0 20 16",
  xmlns: "http://www.w3.org/2000/svg"
};
var getStatusText = function getStatusText(status, isHighlighted) {
  var label = (0, _utils.getStatusLabel)(status).toLocaleLowerCase();
  if (isHighlighted) {
    return "<em>".concat(label, "</em>");
  }
  return label;
};
var getStatusesText = function getStatusesText(statuses, highlights) {
  return statuses.map(function (status) {
    return getStatusText(status, highlights.includes(status));
  }).reduce(function (accum, status, index, array) {
    // if is the first element
    if (!accum) {
      return status;
    }

    // if is the last element
    if (index + 1 === array.length) {
      return "".concat(accum, " and ").concat(status);
    }

    // if is other case
    return "".concat(accum, ", ").concat(status);
  }, '');
};
var Statuses = function Statuses(_ref) {
  var statuses = _ref.statuses;
  var isPortalReArchitectureEnabled = (0, _exchangeReactHooks.useFeatureFlag)(_constants.PORTAL_RE_ARCHITECTURE_ENABLED);
  var rootStoreContext = (0, _react.useContext)(_exchangeReactHooks.RootStoreContext);
  var useSelector = (0, _reactRedux.createSelectorHook)(_exchangeReactHooks.RootStoreContext);
  var homeQuery = useSelector(function (state) {
    var _state$common;
    return (_state$common = state.common) === null || _state$common === void 0 ? void 0 : _state$common.homeQuery;
  });
  if (!isPortalReArchitectureEnabled || !(statuses !== null && statuses !== void 0 && statuses.length)) {
    return null;
  }
  var highlights = [];
  if (rootStoreContext) {
    highlights = (0, _arrays.convertToArray)(homeQuery === null || homeQuery === void 0 ? void 0 : homeQuery.status);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "lifecycle-statuses",
    className: styles.lifecycleMinorStatusesContainer
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xs",
    className: styles.icon
  }, /*#__PURE__*/_react.default.createElement(LifecycleStateIcon, {
    "data-test-id": "lifecycle-state-icon"
  })), /*#__PURE__*/_react.default.createElement("span", {
    "data-test-id": "lifecycle-statuses-text"
  }, /*#__PURE__*/_react.default.createElement(_exchangeUiComponents.Highlight, null, "Contains ".concat(getStatusesText(statuses, highlights), " versions"))));
};
var _default = exports.default = Statuses;
//# sourceMappingURL=Statuses.js.map